const TrainingList = () => import('@/vuepage/training-manage/TrainingList');
const TrainingListDialog = () => import('@/vuepage/training-manage/TrainingListDialog');
const TrainingListDetail = () => import('@/vuepage/training-manage/TrainingListDetail');
const TrainingRec = () => import('@/vuepage/training-manage/TrainingRec');
const TrainingType = () => import('@/vuepage/training-manage/TrainingType');

export default [{
		path: '/training-list',
		component: TrainingList,
		meta: [{
				name: '培训管理'
			},
			{
				name: '培训列表',
				activeRoute: '/training-list'
			}
		]
	},
	{
		path: '/training-list-dialog',
		component: TrainingListDialog,
		meta: [{
				name: '培训管理'
			},
			{
				name: '培训列表',
				activeRoute: '/training-list'
			},
			{
				name: '新增/编辑培训',
				activeRoute: '/training-list-dialog'
			}
		]
	},
	{
		path: '/training-list-detail',
		component: TrainingListDetail,
		meta: [{
				name: '培训管理'
			},
			{
				name: '培训列表',
				activeRoute: '/training-list'
			},
			{
				name: '培训详情',
				activeRoute: '/training-list-detail'
			}
		]
	},
	{
		path: '/training-rec',
		component: TrainingRec,
		meta: [{
				name: '培训管理'
			},
			{
				name: '培训推荐管理',
				activeRoute: '/training-rec'
			},
		]
	},
	{
		path: '/training-type',
		component: TrainingType,
		meta: [{
				name: '培训管理'
			},
			{
				name: '培训分类管理',
				activeRoute: '/training-type'
			},
		]
	},


];